var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OpportunityDetails',{attrs:{"ratio":1/2,"title":_vm.$t('Operation details'),"next-title":_vm.$t('Kerala Analysis'),"opportunity-attribute":"operationDetails","next-link":"kerala-analysis","back-route":"summary"}})}
var staticRenderFns = []

export { render, staticRenderFns }